<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-7" xl="6">
                        <div class="font-weight-bold body-1">
                            Editar cobro
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="7" xl="6">
                        <v-form ref="form" @submit.prevent="save">
                            <income-form :key="componentKey" ref="IncomeForm" :values="form" @save="save" :serverErrors="serverErrors" :edit="true" :inputCreditNotes="inputCreditNotes"></income-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="7" xl="6" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../helpers/Utils';
import Object2Form from '../../helpers/Object2Form';
import IncomeForm from "./Form.vue";


export default {
    components: {
        'income-form': IncomeForm,
    },
	data(){
		return {
            slug: this.$route.params.slug,
            componentKey: 0,
            loading: false,
            serverErrors: {},
            inputCreditNotes: [],
            form: {
                type: "INGRESO",
                date: "",
                concept: "",
                customer_id: "",
                payment_method_id: "",
                description: "",
                subtotal: "",
                taxes: "",
                total: "",
                uuid: "",
                currency: "",
                bank_account_id: "",
                vaucher: "",
                vaucher_file: [],
                commentary: "",
                receivable_account_id: "",
                reference_id: "",
                balanceables: [],
                bank_id: '',
                exchange_rate: 1,
                credit_note_id:'',

                commissions: 0,
                commissions_total: 0,
                commissions_uuid: "", 
                commissions_currency: "",

                invoice_pdf_file:[],
                invoice_pdf_path:"",

                add_invoices:0,
                invoices:[],


                add_complement:0,
                complement_pdf_file: [],
                complement_pdf_path: "",
                complement_xml_file:[],
                complement_xml_path:"",
                complement_folio: '',
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Incomes",
                block:false,
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar cambios",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
            actions: [
				{
					name: 'Borrar',
					icon: {
						color: 'warning',
						icon: 'mdi-delete-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'deleteTableItem'
				},
			],
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {
		validate () {
            //console.log(this.serverErrors);
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
           
            // this.forceRerender();
			return this.$refs.form.validate() && this.form.balanceables.length>0;
            // return true;
		},
        forceRerender() {
            this.componentKey += 1;
        },
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        index()
        {
            this.loading = true;
            this.$store.state.loading = true;
            this.$api.income.get(this.$store.state.business, this.slug)
                .then((resp) => {
                    //console.log(this.$refs.IncomeForm.actions);
                    this.form = {
                        exchange_rate: 1,
                        balanceables:[],
                        ...resp.data,
                        bank_account_id: resp.data?.bank_account?.slug??"",
                        customer_id: resp.data.customer.slug, 
                        payment_method_id: resp.data.payment_method.slug,
                        vaucher_file:[],
                        currency: resp.data?.currency??"",
                        vaucher: resp.data.vaucher_path??'',
                        credit_note_id: resp.data?.credit_note?.slug??"",

                        complement_xml_file: [],
                        complement_xml_path: resp.data.complement_xml_url,
                        complement_pdf_file: [],
                        complement_pdf_path: resp.data.complement_pdf_url,
                    };
                    if((this.form.payment_method_id != 'notas-de-credito' || this.form.payment_method_id != 'descuento') && resp.data?.bank_account != null){
                        this.form.currency = resp.data?.bank_account.currency;
                    }
                    this.inputCreditNotes.push({...resp.data.credit_note})
                    if(resp.data.add_invoices){
                        resp.data.invoices.forEach(element => {
                            let total = element.total - element.balance;
                            total = element.total - total;
                            this.form.balanceables.push({
                                folio: element.invoice_number,
                                id: element.slug,
                                amount: {MXN: element.pivot.amount, USD: element.pivot.amount},
                                balance_due: {MXN: total, USD: total},
                                total: total,
                                currency: element.currency,
                                current_mxn_per_usd: element.current_mxn_per_usd,
                                payment_method: element?.payment_method??null,
                                actions : JSON.parse(JSON.stringify(this.actions)),
                                parameters: { id: element.slug },
                            })
                        });
                    }else{
                        resp.data.receivable_accounts.forEach(element => {
                            this.form.balanceables.push({
                                folio: element.folio,
                                id: element.slug,
                                amount: {MXN: element.pivot.amount, USD: element.pivot.amount},
                                balance_due: {MXN: element.total - element.balance, USD: element.total - element.balance},
                                total: element.total - element.balance,
                                currency: element.currency,
                                payment_method: element?.payment_method??null,
                                current_mxn_per_usd: element.current_mxn_per_usd,
                                actions : JSON.parse(JSON.stringify(this.actions)),
                                parameters: { id: element.slug },
                            })
                        });
                    }
                    
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                    this.$store.state.loading = false;
                })
            ;
        },
        save(){
            
            console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                // console.log(form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.income.update(this.$store.state.business,this.slug, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);
                        this.$router.push({name: 'Incomes'});
                    })
                    .catch((error) => {
                        //console.log(error.response)
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                //console.log(99, error.response);
                                if(("error" in error.response.data)){
                                    Object.keys(error.response.data.error).forEach((x) => {
                                        //console.log(x);
                                        this.serverErrors = error.response.data.error;
                                        error.response.data.error[x].forEach((y) => {
                                            this.serverErrors[x] = Utils.deleteWord(x,y);
                                            errors.push(Utils.deleteWord(x,y))
                                        })
                                    });
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }

                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));
            // console.log(data);
            //commissions
            data.commissions = data.commissions ? "1" : "0";

            if(data.commissions == "0"){
                data.commissions_currency = "",
                data.commissions_total = 0;
                data.commissions_uuid = "";
            }
            
            data.vaucher_file = request.vaucher_file;
            data.bank_id = data.bank_account_id;

            data.balanceables = request.balanceables.map((x) => {
                let finalItem = {id: x.id, amount: `${x.amount[request.currency ? request.currency : x.currency]}` }
                return finalItem;
            });

            if(request.add_invoices){
                data.invoices = JSON.parse(JSON.stringify(data.balanceables));
                data.balanceables = [];
                data.add_invoices = "1";
            }else
            {
                data.add_invoices = 0;
            }

            if(request.vaucher == '' && (request.vaucher_file instanceof Array))
                data.vaucher_file = null;

            if(request.vaucher != '' && (request.vaucher_file instanceof Array))
                delete data.vaucher_file;

            delete data.receivable_accounts;
            delete data.bank_account;
            delete data.customer;
            delete data.payment_method;

            if(data.payment_method_id == 'notas-de-credito' || data.payment_method_id == 'descuento')
                delete data.bank_account_id;


            if(data.payment_method_id != 'notas-de-credito')
                delete data.credit_note_id;

            if(data.payment_method_id != "descuento")
                delete data.currency;




            data.complement_pdf_file = request.complement_pdf_file;
            data.complement_xml_file = request.complement_xml_file;

           

            if(request.complement_pdf_path == '' && (request.complement_pdf_file instanceof Array))
                data.complement_pdf_file = null;

            if(request.complement_xml_path == '' && (request.complement_xml_file instanceof Array))
                data.complement_xml_file = null;


            
            if(data.add_complement == 1){
                data.add_complement = 1;
            }else{
                delete data.complement_pdf_file;
                delete data.complement_xml_file;
                delete data.complement_pdf_path;
                delete data.complement_xml_path;
                delete data.complement_folio;


                data.add_complement = 0;
            }


            // console.log(data);
            return Object2Form.objectToFormData(data,'',[]);
            // return data;
        }
    },
}
</script>

<style>

</style>